/**
 * "Leve junto com desconto" — adicionar direto do carrinho.
 * Mesma técnica do bdl-pdp.js: POST /cart/add.js + CartAddEvent, que o
 * component-cart-items.js do próprio Horizon já escuta pra re-renderizar
 * os itens do carrinho sozinho (Section Rendering). Nenhum DOM patch manual aqui.
 */
import { CartAddEvent, CartErrorEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-bdl-cart-upsell-add]') : null;
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Adicionando…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    const data = await response.json();

    if (!response.ok) {
      document.dispatchEvent(
        new CartErrorEvent('bdl-cart-upsell', data.message, data.description, data.errors)
      );
      button.textContent = 'Tente novamente';
      window.setTimeout(() => {
        button.textContent = originalLabel;
        button.disabled = false;
      }, 2000);
      return;
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    document.dispatchEvent(
      new CartAddEvent(cart, 'bdl-cart-upsell', {
        itemCount: cart.item_count,
        variantId: String(variantId),
      })
    );

    button.textContent = 'Adicionado ✓';
    window.setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 1500);
  } catch (error) {
    button.textContent = 'Tente novamente';
    window.setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 2000);
  }
});
